"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onSetupDone: function() {
          if (!window.Extensions.quit(this.input.meta.name)) {
            return;
          }

          this.emit("setup-done");

          this.emit("dismiss");
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/SetupShell.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    Extension_template = require("../../components/Extension/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Extension_tag = marko_loadTag(Extension_template),
    WSAdapt_template = require("../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Row_template = require("../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "position-absolute zindex-2 w-100 h-100 top-0 left-0 d-flex align-items-center center"
      },
    marko_attrs1 = {
        "class": "position-fixed top-0 w-100 h-100 theme-bg-transparent animated fadeIn faster"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  Row_tag({
      class: "m-0 w-100 d-flex justify-content-center",
      renderBody: function(out) {
        out.e("div", marko_attrs1, "2", component, 0, 0, {
            onclick: __component.d("click", () => component.emit('dismiss'), false)
          });

        WSAdapt_tag({
            ns: "col-md-6 col-10",
            qs: "col-md-8 col-10",
            hs: "col-10",
            class: "theme-bg rounded shadow-lg py-2 overflow-auto",
            style: "min-height:300px;max-height:75vh;",
            renderBody: function(out) {
              Extension_tag(marko_assign({
                  name: input.meta.name
                }, input.meta), out, __component, "4", [
                [
                  "setup-done",
                  "onSetupDone",
                  false
                ],
                [
                  "quit",
                  () => component.emit('dismiss'),
                  false
                ]
              ]);
            }
          }, out, __component, "3");
      }
    }, out, __component, "1");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
